import { Device, Theme } from '@livecontrol/core-ui';
import { Modal } from '@livecontrol/scheduler/components';
import cx from 'classnames';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import styled from 'styled-components';
import shallow from 'zustand/shallow';
import { SmartSearch } from '../../../../components';
import { useEventsStore } from '../../store';
import { DateRange } from './date-range';
import { EventType } from './event-type';
import { Sort } from './sort';

const StyledMobileDateRange = styled(DateRange)`
  > button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
`;

export const Filters = ({
  className,
  showFilters: { eventType, dateRange, sort }
}: {
  className?: string;
  showFilters: { sort: boolean; dateRange: boolean; eventType: boolean };
}): React.ReactElement => {
  const viewport = Theme.useViewport();
  const [showModal, setShowModal] = useState(false);
  const isMobile = Device.isMobile(viewport);

  const { search, setSearch } = useEventsStore((v) => ({
    search: v.filters.search,
    setSearch: v.setSearch
  }), shallow);

  return isMobile ? (
    <div className={className}>
      <div className='d-flex'>
        <Button
          variant='outline-lightgrey'
          onClick={(): void => {
            setShowModal(true);
          }}
        >
          <i className='far fa-sort mr-8px' /> Filters
        </Button>
        <SmartSearch className='ml-12px flex-grow-1' search={search} onSearch={setSearch} />
      </div>
      <Modal
        size='sm'
        show={showModal}
        onHide={(): void => {
          setShowModal(false);
        }}
        contentClassName='bg-dusk text-white'
        className='mx-auto'
      >
        <Modal.Header className='align-items-start' closeButton>
          <h1 className='text-left'>Filtering</h1>
        </Modal.Header>
        <Modal.Body className='justify-content-'>
          <div className='d-flex flex-column align-items-stretch w-100'>
            {eventType && (
              <EventType className='w-100 d-flex align-items-center justify-content-between' />
            )}
            {dateRange && <StyledMobileDateRange className='mt-12px w-100' />}
            {sort && (
              <Sort className='mt-12px w-100 d-flex align-items-center justify-content-between' />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Modal.Button
            className='mt-12px'
            onClick={(): void => {
              setShowModal(false);
            }}
          >
            Apply
          </Modal.Button>
        </Modal.Footer>
      </Modal>
    </div>
  ) : (
    <div className={cx('d-flex justify-content-end', className)}>
      {eventType && <EventType />}
      {dateRange && <DateRange isOldVersion className='ml-12px'/>}
      {sort && <Sort className='ml-12px' />}
      <SmartSearch
        className='ml-12px'
        style={{
          maxWidth: 250
        }}
        search={search}
        onSearch={setSearch}
      />
    </div>
  );
};
